export const WORKFLOW = {
  to_verify: { label: 'Da verificare', className: 'bg-slate-100 text-slate-700 border-slate-300' },
  verified: { label: 'Verificato', className: 'bg-sky-100 text-sky-800 border-sky-300' },
  declared: { label: 'Dichiarato', className: 'bg-indigo-100 text-indigo-800 border-indigo-300' },
  paid: { label: 'Versato', className: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
  anomaly_investigating: { label: 'Anomalia in esame', className: 'bg-rose-100 text-rose-800 border-rose-300' },
  anomaly_resolved: { label: 'Anomalia risolta', className: 'bg-teal-100 text-teal-800 border-teal-300' },
};

export const SEVERITY = {
  critical: { label: 'Critica', className: 'bg-red-100 text-red-800 border-red-300' },
  high: { label: 'Alta', className: 'bg-orange-100 text-orange-800 border-orange-300' },
  medium: { label: 'Media', className: 'bg-amber-100 text-amber-800 border-amber-300' },
  low: { label: 'Bassa', className: 'bg-blue-100 text-blue-800 border-blue-300' },
  matched: { label: 'Quadrata', className: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
};

export const fmtEur = (value) => value === null || value === undefined
  ? '—'
  : Number(value).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });

export const fmtDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString('it-IT');
};

export const periodLabel = (item) => {
  const months = (item.period_months || []).map((month) => (
    ['', 'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'][month]
  )).join('/');
  return `${months || 'Anno'} ${item.period_year || ''}`.trim();
};

export const itemMatchesSeverity = (item, filter) => {
  if (filter === 'all') return true;
  if (filter === 'matched' || filter === 'critical') return item.severity === filter;
  const codes = (item.anomalies || []).map((anomaly) => anomaly.code);
  if (filter === 'overpaid') return codes.some((code) => ['OVERPAID', 'OVERCOLLECTED'].includes(code));
  if (filter === 'underpaid') return codes.some((code) => ['UNDERPAID', 'UNDERCOLLECTED'].includes(code));
  if (filter === 'missing') return codes.some((code) => code.includes('MISSING') || code.includes('UNKNOWN'));
  return true;
};

export const summarize = (items) => ({
  total_items: items.length,
  total_collected: items.reduce((sum, item) => sum + Number(item.collected_guests_amount || 0), 0),
  total_due: items.reduce((sum, item) => sum + Number(item.theoretical_due_amount || 0), 0),
  total_declared: items.reduce((sum, item) => sum + Number(item.declared_portal_amount || 0), 0),
  total_paid: items.reduce((sum, item) => sum + Number(item.paid_actual_amount || 0), 0),
  net_variance: items.reduce((sum, item) => sum + Number(item.delta_paid_vs_due || 0), 0),
  anomalies_count: items.filter((item) => !['matched', 'low'].includes(item.severity)).length,
  critical_count: items.filter((item) => item.severity === 'critical').length,
});